<template>
  <div class="modal" @keydown.enter="handleEnterKey" @keydown.esc="$emit('close')">
    <div class="modal-content">
      <div class="modal-header">
        <h1>Create site</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" @click="$emit('close')"
                aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form @submit.prevent="submitForm">
          <div class="mb-3">
            <label for="code" class="form-label">Code</label>
            <input type="text" class="form-control" id="code" v-model="code" ref="inputCode" required
                   placeholder="Short site code"/>
            <div v-if="siteCodeError" class="text-danger">{{ siteCodeError }}</div>
          </div>
          <div class="mb-3">
            <label for="name" class="form-label">Name</label>
            <input type="text" class="form-control" id="name" v-model="name" required placeholder="Full site name"/>
            <div v-if="siteNameError" class="text-danger">{{ siteNameError }}</div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="$emit('close')">Cancel</button>
        <button type="button" class="btn btn-primary" @click="submitForm" :disabled="isCreateButtonDisabled">Create
          site
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {checkSiteCodeUnique, checkSiteNameUnique} from "@/utils/mycrew_functions";

export default {
  name: 'CreateSiteModal',
  props: {
    organisation: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      code: '',
      siteCodeError: '',
      name: '',
      siteNameError: '',
    };
  },
  computed: {
    isCreateButtonDisabled() {
      return this.code === '' ||
          this.name === '' ||
          this.siteCodeError !== '' ||
          this.siteNameError !== '';
    },
  },
  mounted() {
    this.$refs.inputCode.focus();
  },
  methods: {
    submitForm() {
      this.$emit('create-site', {code: this.code.trim(), name: this.name.trim()});
      this.$emit('close');
    },
    handleEnterKey() {
      if (!this.isCreateButtonDisabled) {
        this.submitForm();
      }
    },
  },
  watch: {
    async code(newSiteCode) {
      if (newSiteCode) {
        const result = await checkSiteCodeUnique(this.organisation.slug, newSiteCode.trim());
        if (result.status === 'unique') {
          this.siteCodeError = '';
        } else {
          this.siteCodeError = 'Site code must be unique';
        }
      } else {
        this.siteCodeError = '';
      }
    },
    async name(newSiteName) {
      if (newSiteName) {
        const result = await checkSiteNameUnique(this.organisation.slug, newSiteName.trim());
        if (result.status === 'unique') {
          this.siteNameError = '';
        } else {
          this.siteNameError = 'Site name is not unique';
        }
      } else {
        this.siteNameError = '';
      }
    }
  },
};
</script>

<style scoped>
.modal {
  display: block;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
}

.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
}

.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}
</style>